import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaLightbulb, FaBug, FaComments, FaGift } from 'react-icons/fa';
import { useTranslation } from '../contexts/TranslationContext.tsx';
import './css/DevelopmentPromoPage.css';

const STEPS = [
  { icon: FaLightbulb, titleKey: 'developmentPromo.step1Title', descKey: 'developmentPromo.step1Desc' },
  { icon: FaBug, titleKey: 'developmentPromo.step2Title', descKey: 'developmentPromo.step2Desc' },
  { icon: FaComments, titleKey: 'developmentPromo.step3Title', descKey: 'developmentPromo.step3Desc' },
] as const;

export default function DevelopmentPromoPage() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('developmentPromo.pageTitle');
    return () => {
      document.title = 'Sciplex';
    };
  }, [t]);

  return (
    <div className="dev-promo-page">
      <div className="dev-promo-container">
        <section className="dev-promo-hero">
          <p className="dev-promo-badge">{t('developmentPromo.badge')}</p>
          <h1 className="dev-promo-title">{t('developmentPromo.title')}</h1>
          <p className="dev-promo-subtitle">{t('developmentPromo.subtitle')}</p>
        </section>

        <section className="dev-promo-section">
          <h2 className="dev-promo-section-title">{t('developmentPromo.howTitle')}</h2>
          <div className="dev-promo-steps">
            {STEPS.map(({ icon: Icon, titleKey, descKey }) => (
              <article key={titleKey} className="dev-promo-step">
                <span className="dev-promo-step-icon" aria-hidden>
                  <Icon />
                </span>
                <h3>{t(titleKey)}</h3>
                <p>{t(descKey)}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="dev-promo-section dev-promo-rewards">
          <div className="dev-promo-rewards-head">
            <span className="dev-promo-rewards-icon" aria-hidden>
              <FaGift />
            </span>
            <h2 className="dev-promo-section-title">{t('developmentPromo.rewardsTitle')}</h2>
          </div>
          <p className="dev-promo-rewards-intro">{t('developmentPromo.rewardsIntro')}</p>
          <ul className="dev-promo-rewards-list">
            <li>{t('developmentPromo.rewardsLi1')}</li>
            <li>{t('developmentPromo.rewardsLi2')}</li>
            <li>{t('developmentPromo.rewardsLi3')}</li>
          </ul>
          <p className="dev-promo-note">{t('developmentPromo.rewardsNote')}</p>
        </section>

        <section className="dev-promo-cta">
          <Link to="/problems/suggest" className="dev-promo-btn dev-promo-btn--primary">
            {t('developmentPromo.ctaSuggest')}
          </Link>
          <a href="mailto:support@sciplex.ru?subject=Sciplex%20feedback" className="dev-promo-btn dev-promo-btn--ghost">
            {t('developmentPromo.ctaFeedback')}
          </a>
        </section>
      </div>
    </div>
  );
}
